import React, { Component, Fragment } from 'react';

class Anchor extends Component {
  render () {
    const { href, className, tabIndex, styles, children, link, id } = this.props;
    // Empty contents
    if (Array.isArray(children) && children.join('') === '') {
      return null;
    };
    // Check for url
    let url = '';
    if (typeof href !== "undefined") {
      url = href;
    } else if (typeof link !== 'undefined') {
      url = link.url;
    } else {
      // No href
      return (
        <Fragment>
          {children}
        </Fragment>
      )
    }
    // valid anchor
    return (
      <a id={id} href={url} tabIndex={tabIndex} className={className} style={styles}>{children}</a>
    );
  }
}

export default Anchor;